<template>
  <WLSegmentedButtons
    :orientation="orientation"
    :variant="variant"
    :buttons="[
      [
        {
          icon: IconName.CONTROLS_MINUS,
          isDisabled: !canSubtract,
          onClick: handleSubtractClick,
        },
      ],
      [
        {
          icon: IconName.CONTROLS_PLUS,
          isDisabled: !canAdd,
          onClick: handleAddClick,
        },
      ],
    ]"
  />
</template>

<script lang="ts" setup>
import { type StepperProps, type StepperEmits } from "./types";
import { toRefs } from "vue";
import { IconName } from "../icon";
import {
  WLSegmentedButtons,
  SegmentedButtonsVariant,
  SegmentedButtonsOrientation,
} from "../segmented-buttons";

const emit = defineEmits<StepperEmits>();
const props = withDefaults(defineProps<StepperProps>(), {
  canAdd: true,
  canSubtract: true,
  variant: SegmentedButtonsVariant.DEFAULT,
  orientation: SegmentedButtonsOrientation.HORIZONTAL,
});

const { canAdd, canSubtract, variant, orientation } = toRefs(props);

const handleSubtractClick = (e: MouseEvent): void => {
  if (canSubtract.value) {
    emit("onSubtract", e);
  }
};

const handleAddClick = (e: MouseEvent): void => {
  if (canAdd.value) {
    emit("onAdd", e);
  }
};
</script>
